export default ({ question }) => {
  const newQuestion = {
    ...question,
    options: []
  }

  return newQuestion
}